import { Link } from "react-router-dom";
import { videoCategories } from "@/mocks/categories";

export default function CategoryShortcuts() {
  return (
    <section>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {videoCategories.map((category) => (
          <Link
            key={category.slug}
            to={`/category/${category.slug}`}
            className="group relative block h-56 overflow-hidden rounded-lg bg-background-200"
          >
            <img
              src={category.cover}
              alt={category.name}
              title={`${category.name} - 樱桃视频`}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-foreground-950/10"></div>
            <div className="absolute inset-0 p-5 flex flex-col justify-end">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i
                    className={
                      category.slug === "short-video"
                        ? "ri-play-circle-line"
                        : category.slug === "net-movie"
                        ? "ri-film-line"
                        : "ri-mic-line"
                    }
                  ></i>
                </span>
                <h3 className="text-lg font-heading font-bold text-background-50">{category.name}</h3>
              </div>
              <p className="mt-2 text-xs leading-relaxed text-background-200 line-clamp-2">
                {category.description}
              </p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {category.subCategories.map((sub) => (
                  <span
                    key={sub}
                    className="rounded-full bg-background-50/20 px-2.5 py-0.5 text-xs text-background-50"
                  >
                    {sub}
                  </span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}